// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ug-0";
export var checkoutRateBadgeLink = "_ug-1";